<mat-form-field *ngIf="control" cropFieldLabel>
  <mat-label
    >{{ 'common.field.timezone' | translate }}{{ isFieldRequired(control) }}
    <ng-container *ngIf="tooltipText">
      <ui-svg-icon
        [name]="iconNames.QuestionFrame"
        [matTooltip]="tooltipText | translate"
        class="help-icon__with-height tw-align-middle"
      ></ui-svg-icon>
    </ng-container>
  </mat-label>
  <mat-select [formControl]="control" [attr.test-id]="testId">
    <mat-option *ngFor="let zone of timezoneList" [value]="zone.utc[0]">
      <span class="zone__text" cropText>{{ zone.text }}</span>
    </mat-option>
  </mat-select>
  <mat-error *ngIf="!control.valid">{{ 'common.validation.error.required' | translate }} </mat-error>
</mat-form-field>
